import { StyledEngineProvider, ThemeProvider } from '@mui/material';
import { StylesProvider, createGenerateClassName } from '@mui/styles';
import { SnackbarProvider } from 'notistack';
import { ReactNode } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import { DialogsProvider } from '~/components/DialogsProvider';
import { LanguageAndLocalizationProvider } from '~/components/SelectedLanguage/component';
import { store } from '~/store';
import { theme } from '~/theme';

import packageData from '~/../package.json';

type Props = {
  children: ReactNode;
};

const generateClassName = createGenerateClassName({
  productionPrefix: 'c',
});

export const Providers = ({ children }: Props) => {
  return (
    <Provider store={store}>
      <StyledEngineProvider injectFirst>
        <StylesProvider generateClassName={generateClassName}>
          <ThemeProvider theme={theme}>
            <BrowserRouter basename={`${packageData.homepage}`}>
              <SnackbarProvider autoHideDuration={5000}>
                <LanguageAndLocalizationProvider>
                  <DialogsProvider>{children}</DialogsProvider>
                </LanguageAndLocalizationProvider>
              </SnackbarProvider>
            </BrowserRouter>
          </ThemeProvider>
        </StylesProvider>
      </StyledEngineProvider>
    </Provider>
  );
};
